module.exports = __webpack_public_path__ + "img/Logo_DAV.0db03cf6.svg";